interface ImageMap {
    [key: string]: string;
}

// no localized image for hu, it, ko, nl, pl, zh, de, es, fr, ja, br, ru
const heroSectionImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:de1966b5-df25-4e7c-8477-ebd8456930c5/jsm-hero-portal.png?cdnVersion=1276"
};

export const getHeroSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return heroSectionImageMap[locale] || heroSectionImageMap["en"]!;
};

// no localized videos available
export const devopsTabSectionVideo =
    "https://dam-cdn.atl.orangelogic.com/AssetLink/8b6d8j2j8bot6l8753taue84xgmdilnt.mp4";

// no localized videos available
export const empowerAllTeamsTabSectionVideo =
    "https://dam-cdn.atl.orangelogic.com/AssetLink/qk55334yq4gd01k1581083dshd3p3d27.mp4";

// no localized videos available
export const deliverValueFastTabSectionVideo =
    "https://dam-cdn.atl.orangelogic.com/AssetLink/0b3qjw6u11w3520ch250j22130hdtc6e.mp4";
